// The mark of a side, beside its name: a sun with eight rays, or a crescent
// moon. Eight rays because the die has eight faces. It takes the text color.

import type { Side } from '../engine/types';
import { svg } from '../lib/svg';

export const MARK_BOX = 24;
const CENTER = MARK_BOX / 2;

const SUN_DISC_RADIUS = 4.5;
const SUN_RAY_COUNT = 8;
const SUN_RAY_WIDTH = 2.4;
const SUN_RAY_LENGTH = 3.6;
const SUN_RAY_INSET = 1;

/** A disc with a smaller disc cut from its upper right. */
const MOON_PATH = 'M14.5 3.2 A9 9 0 1 0 20.8 13.5 A7 7 0 0 1 14.5 3.2 Z';

const sunRay = (index: number): SVGRectElement =>
  svg('rect', {
    x: CENTER - SUN_RAY_WIDTH / 2,
    y: SUN_RAY_INSET,
    width: SUN_RAY_WIDTH,
    height: SUN_RAY_LENGTH,
    transform: `rotate(${(360 / SUN_RAY_COUNT) * index} ${CENTER} ${CENTER})`,
  });

/** The shapes of the mark, in a box of `MARK_BOX`. The die of the coin flip draws them on its faces. */
export const SIDE_MARK_SHAPES: Record<Side, () => SVGElement[]> = {
  gold: () => [
    svg('circle', { cx: CENTER, cy: CENTER, r: SUN_DISC_RADIUS }),
    ...Array.from({ length: SUN_RAY_COUNT }, (_, index) => sunRay(index)),
  ],
  violet: () => [svg('path', { d: MOON_PATH })],
};

export const createSideMark = (side: Side): SVGSVGElement =>
  svg(
    'svg',
    {
      class: `side-mark side-mark--${side}`,
      viewBox: `0 0 ${MARK_BOX} ${MARK_BOX}`,
      'aria-hidden': 'true',
    },
    SIDE_MARK_SHAPES[side](),
  );
